import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import AtomLabel from '@s-ui/react-atom-label'
import AtomTooltip, {AtomTooltipPlacements} from '@s-ui/react-atom-tooltip'
import {useSuiContext} from '@s-ui/react-context'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'

import {BASE_ELEMENTS_TYPES, LABEL_WRAPPER_CLASS_NAME} from '../../config.js'
import {INFO_ICON_ROLE} from '../LegendWrapper/config.js'

const FilterWrapperBasicLabelWrapper = ({description, id, showLabel, label, nodeLabel}) => {
  const {i18n} = useSuiContext()

  const TOOLTIP_ID = `filter-wrapper-basic-label-tooltip-${id}`

  return showLabel ? (
    <div className={LABEL_WRAPPER_CLASS_NAME}>
      {label && <AtomLabel text={label} />}
      {Boolean(nodeLabel) && nodeLabel}
      {description && (
        <AtomTooltip content={<div id={TOOLTIP_ID}>{description}</div>} placement={AtomTooltipPlacements.AUTO}>
          <div
            aria-describedby={TOOLTIP_ID}
            aria-label={i18n.t('FILTERS.TOOLTIP.LABEL')}
            role={BASE_ELEMENTS_TYPES.BUTTON}
          >
            <IconInfoOutline aria-hidden role={INFO_ICON_ROLE} size={atomIconSizes.medium} />
          </div>
        </AtomTooltip>
      )}
    </div>
  ) : (
    <VisuallyHidden as={BASE_ELEMENTS_TYPES.LABEL}>{label}</VisuallyHidden>
  )
}

FilterWrapperBasicLabelWrapper.displayName = 'FilterWrapperBasicLabelWrapper'
FilterWrapperBasicLabelWrapper.propTypes = {
  description: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  nodeLabel: PropTypes.node,
  showLabel: PropTypes.bool
}

export default FilterWrapperBasicLabelWrapper
